import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

export const selectClientReferrers = ({ main }: RootState) => main.clientReferrers.rows;

export const selectClientReferrerNames = createSelector(selectClientReferrers, (rows) =>
  rows.map(({ name }) => ({
    id: name,
    name,
  })),
);
